import { useMemo, useEffect } from 'react'
import { useRouter } from 'next/router'

export function useValidateQuerySearch (searchSchema) {
  const router = useRouter()
  const { search = '', pathname } = window.location
  const result = useMemo(() => {
    const searchParams = new URLSearchParams(search)
    let isValid = true
    for (const key of searchParams.keys()) {
      if (!searchSchema[key]) {
        searchParams.delete(key)
        isValid = false
      } else {
        if (
          searchSchema[key].test &&
          !searchSchema[key].test(searchParams.get(key))
        ) {
          isValid = false
          searchSchema[key].required
            ? searchParams.set(key, searchSchema[key].default)
            : searchParams.delete(key)
        }
      }
    }

    const validSearchKeys = Object.keys(searchSchema)
    validSearchKeys.forEach(key => {
      if (!searchParams.has(key) && searchSchema[key].required) {
        isValid = false
        searchParams.set(key, searchSchema[key].default)
      }
    })
    const queryData = {}
    searchParams.forEach((value, key) => {
      queryData[key] = value
    })
    const validatedQuerySring = searchParams.toString()
    return {
      isValid,
      to: `${pathname}?${validatedQuerySring}`,
      queryData,
      currentSearch: encodeURIComponent(validatedQuerySring),
      hasInitialQuery: !!search,
      router
    }
  }, [search])

  useEffect(() => {
    if (!result.isValid) {
      router.replace(result.to)
    }
  })
  return result
}

export function useShouldRedirectToLastPage (paginatedData) {
  const router = useRouter()
  useEffect(() => {
    if (paginatedData?.pageable) {
      const { number, totalPages } = paginatedData
      if (totalPages - 1 < number && number != 0) {
        const search = new URLSearchParams(router.query)
        search.set('page', totalPages || 1)
        router.replace(`${router.pathname}?${search.toString()}`)
      }
    }
  }, [paginatedData])
}

export function useHandleChangePage () {
  const router = useRouter()
  return ({ current, pageSize }) => {
    const search = getSearchUrl(router.query, {
      page: current,
      size: pageSize
    })
    router.push(`${router.pathname}?${search}`)
  }
}

export function getSearchUrl (curSearch, params) {
  const searchParams = new URLSearchParams({ ...curSearch, ...params })
  return searchParams.toString()
}
